import {
  appFormUtil,
  gqlCacheUtil
} from 'modules/common';
import React, { useEffect } from 'react';

import {
  CreateRooms_Input,
  GetAllProjectsDocument,
  GetAllProjectsQuery,
  SaveProjectMutation,
  useCreateRoomsMutation
} from 'generated/graphql';
import _ from 'lodash';



export type IFormState = {
  displayName: string;
  areaId: string;
  projectId: string;
};

const initialState: IFormState = {
  displayName: '',
  areaId: '',
  projectId: ''

};

export function useFormState(id: string) {
  const { formState, dispatch, genFieldProps } = appFormUtil.useFormState({
    initialState,
    key2FieldConfig: {
      displayName: {
        label: 'Room Name',
        type: 'text'
      },
      areaId: {
        label: 'Area',
        type: 'text'
      },
      projectId: {
        label: 'Project id',
        type: 'text'
      }
    }
  });

  useEffect(() => {
    if (formState.projectId === '' && id !== '') {
      dispatch({
        type: 'UPDATE',
        payload: {
          property: 'projectId',
          value: id
        }
      });
    }
    return () => {};
  }, [
    dispatch,
    formState.projectId,
    id
  ]);

  return React.useMemo(
    () => {

      return {
        formState,
        dispatch,
        genFieldProps
      };
    },
    [
      dispatch,
      formState,
      genFieldProps
    ]
  );
}

export function useCreateRooms() {
  const [
    fnMutate,
    tuple
  ] = useCreateRoomsMutation({
    refetchQueries: []
  });
  const fnWrappedMutate = React.useCallback(
    async (input: CreateRooms_Input) => {
      await fnMutate({
        variables: {
          input
        },
        updateQueries: {
          ...gqlCacheUtil.genUpdateQueryMap<GetAllProjectsQuery, SaveProjectMutation>(
            GetAllProjectsDocument, (prevState, { mutationResult }) => {
              if (!prevState.projects || !mutationResult.data?.saveProject) {
                return prevState;
              }

              const exists = prevState.projects?.find((node) => node.id === mutationResult.data?.saveProject?.id);
              const newProjects = prevState.projects.map((node) => {
                if (node.id !== mutationResult.data?.saveProject?.id) {
                  return node;
                }
                return {
                  ...node,
                  ...mutationResult.data.saveProject
                };
              });

              if (exists) {
                return {
                  ...prevState,
                  projects: _.compact([...newProjects])
                };
              }
              return {
                ...prevState
              };
            }
          )
        }
      });
    },
    [fnMutate]
  );

  return React.useMemo(
    () => [
      fnWrappedMutate,
      {
        ...tuple,
        data: null
      }
    ] as const,
    [
      fnWrappedMutate,
      tuple
    ]
  );
}
